import { Box, Result } from '@/lib/types';
import { AxiosError } from 'axios';
import { media_client } from '../../';

export default {
    async add(name: string): Promise<Result<boolean, AxiosError>>{
        try{

            await media_client.put(`/tags`, {
                name
            });
            return {
                ok: new Box<boolean>(true),
                err: null
            }

        }catch(err){

            return {
                ok: null,
                err: new Box<AxiosError>(err as AxiosError)
            }

        }
    },
    async search(q: string): Promise<Result<string[], AxiosError>>{

        try{

            const results = await media_client.get(`/tags?query=${q}`);
            return {
                ok: new Box<string[]>(results.data.tags as string[]),
                err: null
            }

        }catch(err){

            return {
                ok: null,
                err: new Box<AxiosError>(err as AxiosError)
            }

        }

    },

}